import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

Injectable();
/* eslint-disable @typescript-eslint/no-explicit-any */
export const LanguageInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next): Observable<HttpEvent<any>> => {
  const translateService = inject(TranslateService);
  const language = translateService.currentLang;
  const BASE_PATH = req.url;
  if (!BASE_PATH.endsWith('.json')) {
    req = req.clone({
      url: BASE_PATH,
      setHeaders: {
        'Accept-Language': language,
      },
    });
  }
  return next(req);
};
